import type { StoredUser } from '../../types';
import { mockStorageKeys, readJson, writeJson } from '../mock/storage';

const ADMIN_EMAIL = 'admin@healthshoplongevity.com';
const ADMIN_PASSWORD = 'admin123';

export function seedAdminIfNeeded() {
  const users = readJson<StoredUser[]>(mockStorageKeys.users, []);
  const hasAdmin = users.some((u) => u.role === 'admin');

  if (hasAdmin) return;

  const adminUser: StoredUser = {
    id: 'admin-user',
    name: 'Admin',
    email: ADMIN_EMAIL,
    password: ADMIN_PASSWORD,
    role: 'admin',
    emailConfirmed: true,
  };

  writeJson(mockStorageKeys.users, [...users, adminUser]);
}

export const defaultAdminCredentials = {
  email: ADMIN_EMAIL,
  password: ADMIN_PASSWORD,
};
